var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01611 2.01586C2.90737 1.12461 4.13961 0.572754 5.50008 0.572754C6.86055 0.572754 8.09279 1.12461 8.98405 2.01586C9.8753 2.90712 10.4272 4.13936 10.4272 5.49984C10.4272 6.86031 9.8753 8.09255 8.98405 8.9838C8.09279 9.87505 6.86055 10.4269 5.50008 10.4269C4.13961 10.4269 2.90737 9.87505 2.01611 8.9838C1.12486 8.09255 0.572998 6.86031 0.572998 5.49984C0.572998 4.13937 1.12486 2.90712 2.01611 2.01586ZM5.50008 1.26025C4.32927 1.26025 3.26984 1.73441 2.50224 2.502C1.73465 3.2696 1.2605 4.32902 1.2605 5.49984C1.2605 6.67065 1.73465 7.73007 2.50224 8.49767C3.26984 9.26526 4.32927 9.73942 5.50008 9.73942C6.67089 9.73942 7.73032 9.26526 8.49791 8.49767C9.26551 7.73007 9.73966 6.67065 9.73966 5.49984C9.73966 4.32903 9.26551 3.2696 8.49791 2.502C7.73032 1.73441 6.67089 1.26025 5.50008 1.26025Z",
    fill: "#0E8ACD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78133 4.26804C3.78133 3.3188 4.55084 2.54929 5.50008 2.54929C6.44932 2.54929 7.21883 3.3188 7.21883 4.26804C7.21883 5.09955 6.62835 5.79316 5.84383 5.95241V6.5597C5.84383 6.74955 5.68993 6.90345 5.50008 6.90345C5.31023 6.90345 5.15633 6.74955 5.15633 6.5597V5.64304C5.15633 5.45319 5.31023 5.29929 5.50008 5.29929C6.06962 5.29929 6.53133 4.83758 6.53133 4.26804C6.53133 3.6985 6.06962 3.23679 5.50008 3.23679C4.93054 3.23679 4.46883 3.6985 4.46883 4.26804C4.46883 4.45789 4.31493 4.61179 4.12508 4.61179C3.93523 4.61179 3.78133 4.45789 3.78133 4.26804Z",
    fill: "#0E8ACD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50008 8.6222C5.81649 8.6222 6.073 8.3657 6.073 8.04929C6.073 7.73288 5.81649 7.47637 5.50008 7.47637C5.18367 7.47637 4.92716 7.73288 4.92716 8.04929C4.92716 8.3657 5.18367 8.6222 5.50008 8.6222Z",
    fill: "#0E8ACD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueQuestionMark);
export default __webpack_public_path__ + "static/media/blue-question-mark.637a2688.svg";
export { ForwardRef as ReactComponent };